<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        巡查统计
      </div>
    </div>
    <div class="flex">
      <unitList v-show="!($store.state.user.userInfo.natureId == 2)" @select="getUnit" @getFirst="getOne"></unitList>
      <div class="flex1">
        <div class="common-page common-tool-bar" style="justify-content: end">
          <div>
            <el-button type="primary" size="small" v-hasPermi="['safe:time:query']" @click="showDia = true">查询</el-button>
            <el-button type="success" size="small" v-hasPermi="['safe:time:export']" @click="outPut">导出数据</el-button>
          </div>
        </div>
        <div class="common-page common-list">
          <el-table :data="list" class="">
            <el-table-column prop="c_point_number" label="巡查点编号" align="center"> </el-table-column>
            <el-table-column prop="c_point_addr" label="巡查点位置" align="center"> </el-table-column>
            <el-table-column prop="c_point_area" align="center" label="所在区域"> </el-table-column>
            <el-table-column prop="c_point_states" align="center" label="是否异常">
              <template slot-scope="scope">
                <el-button type="info" size="mini" plain v-if="scope.row.c_point_error == null">待检查</el-button>
                <el-button v-else plain size="mini" :type="scope.row.c_point_error == 0 ? 'info' : scope.row.c_point_error == 1 ? 'danger' : 'success'">
                  {{ $map.isNormal[scope.row.c_point_error] }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="sumcount" align="center" label="巡查次数"> </el-table-column>

            <el-table-column label="操作" align="center" fixed="right">
              <template slot-scope="scope">
                <router-link
                  :to="{
                    path: '/safe/safe-record',
                    query: { id: scope.row.c_point_number },
                  }"
                  v-hasPermi="['safe:time:edit']"
                >
                  <el-button size="mini" type="primary">详情</el-button>
                </router-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination background layout="prev, pager, next" @current-change="pageChange" :page-size="10" :total="total"> </el-pagination>
      </div>
    </div>
    <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
      <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"> </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
        <el-button @click="cancle" size="small">重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import {getCompanyList,switchCompany} from '../../api/company'
import unitList from '@/components/unitList';
export default {
  data() {
    return {
      list: [],
      params: {
        page: 1,
        c_point_addr: '',
        c_point_error: '',
        starttime: '',
        c_company_num: this.cpNum || this.$store.state.user.company.cCompanyNum,
        c_point_number: '',
        endtime: '',
        c_point_area: '',
      },
      cpNum: '',

      outPutForm: {},
      total: 0,
      showDia: false,
      searchForm: this.$getForm('xctongjiSearch'),
      editData: {},
      remoteFuncs: {},
    };
  },
  created() {
    this.getList();
  },
  components: {
    unitList,
  },
  watch: {
    cpNum() {
      this.params.c_company_num = this.cpNum;
      this.params.page = 1;
      // this.getDatas()
      this.getList();
    },
  },
  methods: {
    cancle() {
      // this.showDia = false;
      this.resetSearch();
    },
    //导出
    outPut() {
      var obj = { ...this.params, ...this.outPutForm };
      var { c_point_area, c_point_addr, c_point_error, starttime, c_point_number, endtime } = obj;
      var url = `${this.$config.apiUrl}/xuncha/tongjidownload?c_company_num=${this.cpNum ||
        this.$store.state.user.company
          .cCompanyNum}&c_point_addr=${c_point_addr}&c_point_error=${c_point_error}&c_point_number=${c_point_number}&starttime=${starttime}&endtime=${endtime}&c_point_area=${c_point_area}`;
      window.location = url;
    },
    changeStatus(id, status) {
      switchCompany({ id, status })
        .then((res) => {
          this.getList();
        })
        .catch((err) => {});
    },
    getList() {
      this.$post('/xuncha/xctongji', this.params).then((res) => {
        this.list = res.data.list;
        this.total = res.data.count;
      });
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;
          this.outPutForm = this.params;

          this.getList();

          this.showDia = false;
        })
        .catch((e) => {});
    },
    getOne(v) {
      this.cpNum = v;
    },
    getUnit(v) {
      this.cpNum = v;
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = {
        page: 1,
        c_point_addr: '',
        c_point_error: '',
        starttime: '',
        c_point_number: '',
        endtime: '',
        c_point_area: '',
        ...this.$refs.searchForm.models,
      };
      this.getList();
    },
  },
};
</script>

<style scoped></style>
